package org.multiplatform.kotfolio.util

import com.varabyte.kobweb.compose.ui.graphics.Color

object Resources {
    object Images {
        const val NAVIGATION_ARROW = "/link_icon.svg"
        const val SEARCH_LIGHT = "images/search.svg"

        // Socials
        const val GITHUB = "images/Socials/github.svg"
        const val GITHUB_FILLED = "images/Socials/github-filled.svg"
        const val LINKEDIN = "images/Socials/linkedin.svg"
        const val MEDIUM = "images/Socials/medium.svg"

        // Flutter Projects
        const val PROJECT_CUSTOMER_SERVICE = "/images/Projects/project_customer_service.png"
        const val PROJECT_MVP_EVENT_STAFFING = "/images/Projects/project_mvp_event_staffing.png"
        const val PROJECT_MIKAN_DELIVERY = "/images/Projects/project_mikan_delivery.png"
        const val PROJECT_FOOD_CAFE = "/images/Projects/project_food_cafe.png"
        const val PROJECT_SERVICE_PROVIDER = "/images/Projects/project_service_provider.png"

        //Jetpack Compose Projects
        const val PROJECT_CODE_ARTICLE = "/images/Projects/project_jc_code_article.png"
        const val PROJECT_CODE_TASKII = "/images/Projects/project_jc_taskii.png"


        const val PROJECT_MONITO_1 = "/images/Projects/kmm_desktop_monito_1.png"
        const val PROJECT_MONITO_2 = "/images/Projects/kmm_desktop_monito_2.png"
        const val PROJECT_MONITO_3 = "/images/Projects/kmm_desktop_monito_3.png"

        const val PROJECT_ATTENDANCE = "/images/Projects/kmm_attendance.png"
        const val PROJECT_MEMORY_MATCH = "/images/Projects/kmm_memory_match.webp"

        const val PROJECT_CRYPTO = "/images/Projects/kmm_crypto.png"

        const val PROJECT_SHOPPING_MALL = "/images/Projects/kmm_shopping_mall.png"

        const val PROJECT_OPTIMITE_MEMORY = "/images/Projects/kmm_desktop_optimite_memory.png"

        const val PROJECT_GRIPPO = "/images/Projects/kmm_grippo.png"

        const val HILT_IMAGE_1 = "/images/compose/hilt_1.webp"

        const val KOIN_WORK = "/images/compose/koin_work_1.webp"

        const val CLEAN_ARCHITECTURE_SOLID = "/images/compose/clean_architecture_solid.webp"

        const val MVI_1 = "/images/compose/mvi.webp"

        //Compose
        const val XML_VS_COMPOSE = "/images/compose/xml_vs_compose.webp"
        const val RENDER_COMPOSE_1 = "/images/compose/render_1.webp"

        const val RECOMPOSITION_PHASE_1 = "/images/compose/recomposition_phase.webp"

        const val RENDER_COMPOSE_2 = "/images/compose/render_2.webp"

        const val VIEWMODEL_LIFECYCLE_1 = "/images/compose/viewmodel_lifecycle.png"

        const val NEW_VIEWMODEL_API = "/images/compose/new_viewmodel_api.webp"

        const val TRANSFORMS_STATE_COMPOSE_1 = "/images/compose/transforms_state_1.webp"
        const val TRANSFORMS_STATE_COMPOSE_2 = "/images/compose/transforms_state_2.webp"
        const val LAYOUT_STAGE_COMPOSE_1 = "/images/compose/layout_stage_1.webp"
        const val LAYOUT_STAGE_COMPOSE_2 = "/images/compose/layout_stage_2.webp"
        const val LAYOUT_STAGE_COMPOSE_3 = "/images/compose/layout_stage_3.webp"
        const val STATE_COMPOSE_1 = "/images/compose/state_compose_1.gif"

        const val COMPOSITION_ARCHI_1 = "/images/compose/composition_archi_1.webp"
        const val COMPOSITION_ARCHI_2 = "/images/compose/composition_archi_2.webp"
        const val COMPOSITION_PATTERNS = "/images/compose/composition_patterns.webp"
        const val COMPOSITION_LOCAL_DI_VS = "/images/compose/composition_local_vs_di.webp"

        //LABEL CROPPING
        const val SELLER_BOX_1 = "/images/labelcropping/sellerbox_1.png"
        const val SELLER_BOX_2 = "/images/labelcropping/sellerbox_2.png"

        //PRODUCT
        const val STEP_LADDER_PRODUCT = "/images/product/step_ladder.jpg"
        const val STEP_LADDER_2_PRODUCT = "/images/product/step_ladder_2.webp"

        const val KITCHEN_TROLLEY_SQUARE_PRODUCT = "/images/product/kitchen_trolley_square.jpg"
        const val KITCHEN_TROLLEY_ROUND_PRODUCT = "/images/product/kitchen_trolley.jpg"

        const val CHOPPING_BOARD_PRODUCT = "/images/product/chopping_board.png"

        const val KITCHEN_TROLLEY_HEXAGON_PRODUCT = "/images/product/kitchen_trolley_hexagon.webp"

        const val MIRROR_CABINET_PRODUCT = "/images/product/mirror_cabinet.webp"

        const val PANNER_PRESS_MAKER_PRODUCT = "/images/product/panner_press_maker.jpg"

        //ARRANGEMENT
        const val ARRANGEMENT_COLUMN = "/images/compose/arrangement_column.webp"
        const val ARRANGEMENT_ROW = "/images/compose/arrangement_row.webp"
        const val ARRANGEMENT_BOX = "/images/compose/arrangement_box.webp"

        //IMMUTABLE
        const val IMMUTABLE_WORK = "/images/compose/immutable_work.webp"

        //Side Effect
        const val SIDE_EFFECT_1 = "/images/compose/side_effect_1.webp"
        const val SIDE_EFFECT_2 = "/images/compose/side_effect_2.jpeg"
        const val SIDE_EFFECT_3 = "/images/compose/side_effect_3.png"
        const val SIDE_EFFECT_4 = "/images/compose/side_effect_4.webp"
        const val SIDE_EFFECT_VS_1 = "/images/compose/launched_effect_vs_remember_coroutine_scope.webp"
        const val SIDE_EFFECT_RETAIN_SCOPE = "/images/compose/side_effect_retain_scope.png"

        //Composable Lifecycle &
        const val COMPOSE_RUNTIME_URL = "i/mages/compose/compose_runtime.svg"
        const val COMPOSE_RUNTIME_RE_COMPOSE_URL = "/images/compose/compose_runtime_re_compose.jpeg"

        const val COMPOSE_COMPILER_URL = "/images/compose/compose_compiler.svg"
        const val COMPOSABLE_LIFECYCLE_URL = "/images/compose/composable_lifecycle.webp"

        const val SETTING_OPTIMIZE_IMPORTS_URL = "/images/compose/setting_optimize_imports.png"

        const val SETTING_LIVE_EDIT_URL = "/images/compose/setting_live_edit.png"

        //COMPOSE CODING
        const val MULTI_MODULE_CODING_1_URL = "/images/compose/coding_multi_module_1.webp"

        //Kotlin Multiplatform / KMM / KMP
        const val BUILD_PHASE = "/images/kmm/script_phase.webp"
        const val KMM_1 = "/images/kmm/kmm_1.webp"
        const val COMPOSE_MULTIPLATFORM = "/images/kmm/compose_multiplatform.webp"
        const val CODE_SHARING_PLATFORM = "/images/kmm/code_sharing_platform.webp"
        const val COMPOSE_MULTIPLATFORM_SHARE_UI = "/images/kmm/compose_multiplatform_share_ui.webp"

        const val KMM_INTERNAL_WORKING = "/images/kmm/kmm_internal_working.png"

        const val DEBUG_SETTING_1 = "/images/kmm/debug_setting.webp"

        const val KMP_WORK = "/images/kmm/kmp_work.webp"

        const val SWIFT_EXPORT_BRIDGE = "/images/kmm/swift_export_bridge.png"

        const val KOTLIN_TO_SWIFT = "/images/kmm/kotlin_to_swift.jpeg"

        //COROUTINES
        const val FLOW_MANAGE_COROUTINES = "/images/coroutines/flow_manage.webp"
        const val FLOW_COLD_VS_HOT = "/images/coroutines/flow_cold_vs_hot.webp"
        const val COROUTINES_COMPONENTS = "/images/coroutines/coroutines_components.webp"
        const val FLOW_BUILDER_CATEGORY_COROUTINES = "/images/coroutines/flow_builder_category.webp"
        const val COROUTINES_LIFECYCLE_1 = "/images/coroutines/coroutine_lifecycle_1.webp"
        const val COROUTINES_LIFECYCLE_2 = "/images/coroutines/coroutine_lifecycle_2.webp"
        const val STATE_FLOW_VS_SHARED_FLOW = "/images/coroutines/state_flow_vs_shared_flow.png"
        const val COLLECT_AS_STATE_WITH_LIFECYCLE = "/images/coroutines/collect_as_state_with_lifecycle.webp"


        //FLUTTER
        const val WIDGET_BUILDCONTEXT_FLUTTER = "/images/flutter/widget_buildcontext.webp"
        const val WIDGET_TREE_RELATIONSHIP_0_FLUTTER = "/images/flutter/widget_relationship_0.webp"
        const val WIDGET_TREE_RELATIONSHIP_1_FLUTTER = "/images/flutter/widget_relationship_1.webp"
        const val WIDGET_TREE_RELATIONSHIP_2_FLUTTER = "/images/flutter/widget_relationship_2.webp"
        const val WIDGET_TREE_RELATIONSHIP_3_FLUTTER = "/images/flutter/widget_relationship_3.webp"

        const val WIDGET_TREE_1_FLUTTER = "/images/flutter/widget_tree_1.webp"
        const val WIDGET_TREE_2_FLUTTER = "/images/flutter/widget_tree_2.webp"
        const val WIDGET_TREE_3_FLUTTER = "/images/flutter/widget_tree_3.webp"

        const val STATE_TYPE_URL = "/images/flutter/state_type.webp"

        const val WIDGET_REBUILD_FLUTTER = "/images/flutter/widget_rebuild.gif"

        const val WIDGET_LIFECYCLE_FLUTTER = "/images/flutter/widget_lifecycle.webp"
        const val CLEAN_ARCHITECTURE_MODEL_FLUTTER = "/images/flutter/clean_architecture_model.webp"

        //FIREBASE
        const val FLUTTER_3_19_5 = "/images/flutter/flutter_3_19_5.webp"
        const val FIREBASE_SETUP_FLUTTER = "/images/flutter/firebase_setup.webp"

        //KIDS
        const val WEATHER = "/images/kids/weather.png"
        const val EARTH = "/images/kids/earth.png"

        const val VISIT_PLACES = "/images/kids/visit_places.png"

        const val SHELTER = "/images/kids/shelter.png"

        const val SHELTER_BUILD_HOUSE = "/images/kids/shelter_build_house.png"

        const val OUR_SCHOOL_WORK = "/images/kids/our_school_work.png"

        const val LITTLE_TURTLE = "/images/kids/little_turtle.png"

        const val COMMUNICATION = "/images/kids/communication_1.png"

        const val COMPREHENSION_2 = "/images/kids/comprehension_2.png"

        const val COMPREHENSION_3 = "/images/kids/comprehension_3.png"

        const val COMPREHENSION_4 = "/images/kids/comprehension_4.png"

        const val STORY_ZEBRA = "/images/kids/story_zebra.png"

        const val STORY_GIRAFFE = "/images/kids/story_giraffe.png"
    }

    object Colors {
        val FOOTER_COLOR_LIGHT = Color.rgb(0, 0, 0)
    }
}

